import { LevelType } from '@app/constants/enums/mouseflow-level';
import { FONT_WEIGHT } from '@app/styles/themes/constants';
import styled from 'styled-components';

export const LEVEL_COLORS: Record<LevelType, string> = {
  [LevelType.HOT]: '#006400',
  [LevelType.WARM]: '#90EE90',
  [LevelType.MEDIUM]: '#FFA500',
  [LevelType.COLD]: '#FF6666',
  [LevelType.FROZEN]: '#8B0000',
};

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;

  tr {
    border-bottom: 1px solid #eef0f3;
    &:last-child {
      border-bottom: none;
    }
  }

  th,
  td {
    padding: 12px 14px;
    text-align: inherit;
    color: #1a295a;
    vertical-align: middle;
  }

  th {
    font-weight: ${FONT_WEIGHT.medium};
    width: 45%;
    background: #f7f8fa;
    color: #56607a;
  }

  td {
    font-weight: ${FONT_WEIGHT.medium};
  }
`;

export const LevelBadge = styled.span<{ $level: LevelType }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 999px;
  font-weight: ${FONT_WEIGHT.medium};
  font-size: 14px;
  color: #fff;
  background: ${({ $level }) => LEVEL_COLORS[$level] || LEVEL_COLORS[LevelType.FROZEN]};

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 50%;
  }
`;

export const EmptyState = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #6b7280;
  font-size: 16px;
`;

export const LoadingWrapper = styled.div`
  padding: 32px;
  display: flex;
  justify-content: center;
`;
